import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, fork, take } from "redux-saga/effects";
import { APIResponseType } from "../../Services/Models/Async/AsyncModel";
import { unknownError } from "../../Utils/Helper";
import { getAlerts } from "./AlertAPI";
import { alertActions } from "./reducer";
import { DashboardAlertFilters } from "./types";

function* getAllAlerts(payload: DashboardAlertFilters){
    try{
        const response: APIResponseType<any> = yield call(getAlerts, payload);
        if(response.success){
            yield put(alertActions.getFilteredAlertsSuccess(response.data));
        }else{
            yield put(alertActions.getFilteredAlertsFail(response.message));
        }
        
    } catch(error){
        if(error instanceof Error) yield put(alertActions.getFilteredAlertsFail(error.message));
        yield put(alertActions.getFilteredAlertsFail(unknownError(error)));
    }
}

function* watchAlertsFlow() {
    while (true) {
        const action: PayloadAction<DashboardAlertFilters> = yield take(alertActions.getFilteredAlertsRequest.type);
        yield put(alertActions.setFilters(action.payload));
        yield fork(getAllAlerts, action.payload);
    }
}

function* AlertSaga(){
    yield fork(watchAlertsFlow);
}
export default AlertSaga;